<ul class="edit-patient--icons">
    <span>
        <i (click)="openEligblPopUpModal()" triggers="mouseover:mouseleave" tooltipClass="custom_tooltip" placement="top" ngbTooltip="{{eligibilityDtTm}}" class="far fa-user-check" aria-hidden="true"></i>
    </span>
</ul>
<ul class="edit-patient--icons" *ngIf="checkHasMergePriv() && patientInfo && patientId">
    <span>
        <a>
            <i (click)="openMergePatient()" class="far fa-exchange-alt" triggers="mouseover:mouseleave" tooltipClass="custom_tooltip" placement="top" ngbTooltip="Merge Patient" aria-hidden="true"></i>
        </a>
    </span>
</ul>
